import { useEffect, useState, useContext } from "react";
import AlertLogLine from "../AlertLogLine";
import API from "../../utils/API"
import { AppContext } from '../../utils/ContextProvider'
import Swal from 'sweetalert2'

const AlertLogsSection = (props) => {

    const context = useContext(AppContext)
    const [logs, setLogs] = useState(null)
    const [buildingUsers, setBuildingUsers] = useState(null)

    useEffect(() => {
        if (!context.getUserInfo || !context.getBuildingInfo) return
        const cancelToken = API.cancelToken();
        if (context.getUserInfo.manage_others_alert_subscription) {
            API.getBuildingUsers(cancelToken, context.getBuildingInfo.building_id).then(res => {
                setBuildingUsers(res.data)
                return
            }).catch(err => {
                console.log(err)
                if (err.message === 'cancelling') return
                Swal.fire({
                    title: 'Error.',
                    text: 'Please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });

            })
        }
        return () => {
            API.cancel(cancelToken);
        }
    }, [context.getUserInfo, context.getBuildingInfo])



    useEffect(() => {
        if (!props.groups || (!props.group && !props.byCircuit)) return
        let tempGroup = { logs: [] }
        if (props.byCircuit) {
            props.groups.forEach(group => {
                tempGroup.logs.push(...JSON.parse(JSON.stringify(group.logs)))
            })
        } else {
            tempGroup = JSON.parse(JSON.stringify(props.group))
        }
        for (let key in tempGroup) {
            if (typeof tempGroup[key] === 'number' && !Number.isInteger(tempGroup[key]) && key.includes('Price')) {
                tempGroup[key] = Math.round(tempGroup[key])
            }
        }
        setLogs(tempGroup.logs)

    }, [props.groups, props.group, props.byCircuit])

    return (
        <div>
            <div className="flex flex-nowrap justify-between items-center mt-[30px] mb-[10px]">
                <h2 className="text-xl font-semibold">Alert Logs</h2>
            </div>
            <div className="flex flex-nowrap items-center justify-between px-4 py-2 w-full text-[12px] text-[#B8BBB9] font-semibold">
                {props.byCircuit && <p className="flex flex-nowrap justify-start items-center w-[100px] text">Severity</p>}
                {props.byCircuit && <p className="flex flex-nowrap justify-start items-center w-[120px] text">Type</p>}
                {props.byCircuit && <p className="flex flex-nowrap justify-start items-center w-[120px] text">Group</p>}
                {!props.byCircuit && <p className="flex flex-nowrap justify-start items-center w-[220px] text">Monitored Point</p>}
                <p className="flex flex-nowrap justify-start items-center w-[120px] text">First Triggered</p>
                <p className="flex flex-nowrap justify-start items-center w-[120px] text">Last Triggered</p>
                <p className="flex flex-nowrap justify-start items-center w-[120px] text"># of Occurrences</p>
                <p className="flex flex-nowrap justify-start items-center w-[100px] text">Assigned To</p>
                <p className="flex flex-nowrap justify-start items-center w-[100px] text">Closed By</p>
                <p className="flex flex-nowrap justify-start items-center w-[120px] text">Closed On</p>
                <p className="flex flex-nowrap justify-start items-center w-[75px] text"></p>
            </div>
            <div className="overflow-y-auto max-h-[250px]">
                {
                    logs && logs.filter(e => props.filter && props.filter.trim() !== "" ? e.point_name.toLowerCase().includes(props.filter.toLowerCase()) : true).map((e, idx) => (
                        <AlertLogLine byCircuit={props.byCircuit} key={idx + "logs"} log={e} equipmentList={props.equipmentList} group={props.group} setGroup={props.setGroup} groups={props.groups} setGroups={props.setGroups} buildingUsers={buildingUsers} />
                    ))
                }
            </div>


        </div>
    )
}

export default AlertLogsSection;